/*
  Dabi Deri — bölüm çapaları.

  Tema düzenleyicide bir bölüme "rezervasyon" adı verilir; Shopify onu
  sayfada `shopify-section-template--…__rezervasyon` kimliğiyle basar. Yani
  `#rezervasyon` bağlantısı doğrudan bir hedef bulamaz. Bu betik tıklanan ve
  adresle gelen `#ad` çapalarını o bölüme eşler, başlığın altına yumuşak
  kaydırır ve odağı taşır. Gerçek bir id varsa ona dokunmaz.
*/
(() => {
  const headerOffset = () => parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dabi-header-bottom')) || 0;

  const resolve = (hash) => {
    const id = decodeURIComponent((hash || '').replace(/^#/, ''));
    if (!id) return null;
    return document.getElementById(id) || document.querySelector(`.shopify-section[id$="__${CSS.escape(id)}"]`);
  };

  const go = (target, push) => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (push) history.pushState(null, '', push);
  };

  document.addEventListener('click', (event) => {
    const a = event.target.closest('a[href*="#"]');
    if (!a || event.defaultPrevented) return;
    const url = new URL(a.href, window.location.href);
    if (url.pathname !== window.location.pathname || url.hash.length < 2) return;
    const target = resolve(url.hash);
    if (!target) return;
    event.preventDefault();
    go(target, url.hash);
  });

  const onLoad = () => {
    if (window.location.hash.length < 2) return;
    const target = resolve(window.location.hash);
    if (target && !document.getElementById(window.location.hash.slice(1))) {
      window.setTimeout(() => go(target, null), 60);
    }
  };
  window.addEventListener('DOMContentLoaded', onLoad);
  window.addEventListener('hashchange', onLoad);
})();
